import React, { Dispatch, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import SmallTabs from '@node-space/storybook-components/dist/SmallTabs'
import { PathNames } from 'constants/General'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useMappedRoles } from 'hooks/useMappedRoles'
import ApiKeys from 'pages/ApiKeys/V2/ApiKeys'
import { IntegrationsTabsOption, IntegrationsTabsOptions } from '../types'
import { Destinations } from './Destinations'

interface ApprovalTabsProps {
  queryTab: IntegrationsTabsOption
  activeTab: IntegrationsTabsOption
  setActiveTab: Dispatch<React.SetStateAction<string>>
}

const IntegrationsTabs = ({ queryTab, activeTab, setActiveTab }: ApprovalTabsProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { profile } = useProfileContext()
  const isAccountViewOnly = !!profile?.viewOnly
  const permissions = useMappedRoles()
  const canViewApiIntegration = permissions?.manageApiIntegration?.canView

  const tabs = [
    {
      id: IntegrationsTabsOptions.HOOKS,
      tabHeader: t('integrations.webhooks'),
      tabContent: <Destinations />,
      onClick: () => {
        navigate(PathNames.INTEGRATIONS, { replace: true })
        setActiveTab(IntegrationsTabsOptions.HOOKS)
      },
    },
  ]

  if (!isAccountViewOnly && canViewApiIntegration) {
    tabs.unshift({
      id: IntegrationsTabsOptions.API_KEYS,
      tabHeader: t('integrations.apiKeys'),
      tabContent: <ApiKeys />,
      onClick: () => {
        navigate(PathNames.INTEGRATIONS, { replace: true })
        setActiveTab(IntegrationsTabsOptions.API_KEYS)
      },
    })
  }

  useEffect(() => {
    if (queryTab) {
      setActiveTab(queryTab)
    }
  }, [queryTab])

  return <SmallTabs tabs={tabs} currentValueId={activeTab} />
}

export default IntegrationsTabs
